module.exports = __webpack_public_path__ + "static/media/mip2.98a5097b.png";